import { FeatureItemType } from "components/MainPage/Features";
import { useTranslation } from "react-i18next";

type Props = FeatureItemType

function FeaturesItem({
	image,
	id,
}: Props) {

	const { t } = useTranslation()

	return (
		<div className="flex bg-stone-50 rounded-3xl shadow flex-col items-center p-6">
			<img src={ image } alt={ t(`mainPage.features.${ id }.title`) } className="h-[80px] lg:h-[110px]"/>
			<div className="text-neutral-900 lg:text-2xl font-semibold mt-4 text-center">
				{ t(`mainPage.features.${ id }.title`) }
			</div>
			<div className="h-0.5 bg-purple-600 w-1/2 my-4"></div>
			<div className="text-center text-neutral-900 text-base lg:text-2sm font-light">
				{ t(`mainPage.features.${ id }.description`) }
			</div>
		</div>
	);
}

export default FeaturesItem;